import React from 'react';

import { useThemeStyles } from '../../lib/useThemeStyles.js';

export interface ThemedCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'small' | 'medium' | 'large';
  shadow?: boolean;
  border?: boolean;
}

/**
 * Themed card component that automatically applies the correct theme colors
 */
export const ThemedCard: React.FC<ThemedCardProps> = ({
  children,
  className = '',
  padding = 'medium',
  shadow = true,
  border = true,
}) => {
  const { colors } = useThemeStyles();
  
  // Determine padding class based on size
  const paddingClass = padding === 'none' 
    ? '' 
    : padding === 'small' 
      ? 'p-4' 
      : padding === 'large' 
        ? 'p-8' 
        : 'p-6';
  
  // Apply shadow if needed
  const shadowClass = shadow ? 'shadow-md' : '';
  
  // Apply border if needed
  const borderClass = border ? `border ${colors.cardBorder}` : '';
  
  // Combine all classes
  const combinedClasses = `
    ${colors.cardBackground}
    ${paddingClass}
    ${shadowClass}
    ${borderClass}
    rounded-lg
    ${className}
  `.trim().replace(/\s+/g, ' ');
  
  return (
    <div className={combinedClasses}>
      {children}
    </div>
  );
};

export default ThemedCard;